/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/login',
      load: () => import(/* webpackChunkName: 'login' */ './login'),
    },
    {
      path: '/websites',
      load: () => import(/* webpackChunkName: 'websites' */ './websites'),
    },
    {
      path: '/project/:project/:type/:lang',
      load: () => import(/* webpackChunkName: 'webpages' */ './webpages'),
    },
    {
      path: '/project/:project/:type/:lang/entries/:id',
      load: () => import(/* webpackChunkName: 'webpages' */ './webpage'),
    },
    {
      path: '/project/:project/:type/:lang/new',
      load: () => import(/* webpackChunkName: 'webpages' */ './webpageNew'),
    },

    {
      path: '/about',
      load: () => import(/* webpackChunkName: 'about' */ './about'),
    },

    {
      path: '/admin',
      load: () => import(/* webpackChunkName: 'admin' */ './admin'),
    },
    {
      path: '/account',
      load: () => import(/* webpackChunkName: 'account' */ './account'),
    },

    {
      path: '/home',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/privacy',
      load: () => import(/* webpackChunkName: 'privacy' */ './privacy'),
    },

    {
      path: '/signup',
      load: () => import(/* webpackChunkName: 'signup' */ './signup'),
    },
    {
      path: '/logged-out',
      load: () => import(/* webpackChunkName: 'loggedOut' */ './loggedOut'),
    },
    {
      path: '/account/password/reset',
      load: () =>
        import(/* webpackChunkName: 'passwordRecovery' */ './passwordRecovery'),
    },
    {
      path: '/reset/:token',
      load: () =>
        import(/* webpackChunkName: 'passwordReset' */ './passwordReset'),
    },
    {
      path: '/verify',
      load: () =>
        import(
          /* webpackChunkName: 'emailVerification' */ './emailVerification'
        ),
    },

    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} | mycompany.org`;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
